// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PressSidebar__sidebarContent___J-rnm{position:-webkit-sticky;position:sticky;top:128px}.PressSidebar__card___2A3x0{margin-top:40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"sidebarContent": "PressSidebar__sidebarContent___J-rnm",
	"card": "PressSidebar__card___2A3x0"
};
module.exports = ___CSS_LOADER_EXPORT___;
